import { ScrollView, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ArrowLeft, BookOpen, Camera, FileCheck2 } from 'lucide-react-native';
import { AppButton } from '../components/ui/AppButton';
import { AppCard } from '../components/ui/AppCard';
import { AppText } from '../components/ui/AppText';
import { tokens } from '../theme/tokens';

const records = [
  {
    id: 'photo',
    title: '二次函数拍照搜题',
    type: '拍照搜题',
    time: '今天 19:20',
    description: '完成 AI 讲解并加入错题本',
    Icon: Camera,
  },
  {
    id: 'lecture',
    title: '勾股定理专项讲解',
    type: '1v1 讲题',
    time: '昨天 20:10',
    description: '追问 3 次，生成同类题练习',
    Icon: BookOpen,
  },
  {
    id: 'correction',
    title: '英语作业批改',
    type: '作业批改',
    time: '周一 18:40',
    description: '标记 2 个语法薄弱点',
    Icon: FileCheck2,
  },
];

export default function LearningRecordsPage() {
  const router = useRouter();

  return (
    <SafeAreaView style={styles.screen}>
      <View style={styles.header}>
        <AppButton
          label="我的"
          variant="ghost"
          onPress={() => router.back()}
          leftSlot={<ArrowLeft size={18} color={tokens.colors.primary} />}
          style={styles.backButton}
        />
        <View style={styles.headerCopy}>
          <AppText variant="title" weight="bold">
            学习记录
          </AppText>
          <AppText variant="caption" tone="muted">
            RecordsScreen 本地记录流
          </AppText>
        </View>
      </View>

      <ScrollView contentContainerStyle={styles.content}>
        {records.map(({ id, title, type, time, description, Icon }) => (
          <AppCard key={id} style={styles.recordCard}>
            <View style={styles.iconWrap}>
              <Icon size={18} color={tokens.colors.primary} />
            </View>
            <View style={styles.recordCopy}>
              <View style={styles.recordTitleRow}>
                <AppText variant="body" weight="bold" style={styles.recordTitle}>
                  {title}
                </AppText>
                <View style={styles.typePill}>
                  <AppText variant="caption" tone="primary" weight="bold">
                    {type}
                  </AppText>
                </View>
              </View>
              <AppText variant="caption" tone="muted">
                {time} · {description}
              </AppText>
            </View>
          </AppCard>
        ))}
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: tokens.colors.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.md,
    paddingBottom: tokens.spacing.sm,
  },
  backButton: {
    minHeight: 40,
    paddingHorizontal: tokens.spacing.sm,
  },
  headerCopy: {
    flex: 1,
  },
  content: {
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.md,
    paddingBottom: tokens.spacing.xxl,
    gap: tokens.spacing.md,
  },
  recordCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  recordCopy: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
  recordTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  recordTitle: {
    flex: 1,
  },
  typePill: {
    borderRadius: tokens.radius.full,
    paddingHorizontal: tokens.spacing.sm,
    paddingVertical: tokens.spacing.xs,
    backgroundColor: tokens.colors.surfaceMuted,
  },
});
